import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=8f7da03e&lang=pug&"
import script from "./UserBar.vue?vue&type=script&lang=js&"
export * from "./UserBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports